// export const BASE_URL = "https://api.eventmoon.com/api";
export const DEV_URL = "https://m.eventmoon.com/api";
export const EVENT_URL = "https://uat.eventmoon.com/api";
export const IP_GEO_API_KEY = "29e935fd72ab4a7ebb00fd12c233d3c4";
export const HERE_API_KEY = "GzVQb87OShdLON4bWiHnap7Ns3FdFESVkgHLhYe82sQ";

export function BASE_URL() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "https://m.eventmoon.com/api";
  } else {
    return "https://api.eventmoon.com/api";
  }
}
